import axiosInstance from 'helpers/axiosInstance';

import { CarePlanFile, Patient } from './patients.type';

interface PatientsResponse {
  patients: Patient[];
}

export const getAccountPatients = async (getPrograms = false) => {
  const url = `/patients/patients${
    getPrograms ? '?completed_care_programs=true' : ''
  }`;
  return axiosInstance.get<PatientsResponse>(url).then(r => r.data.patients);
};

export const getPatientTasks = async (patientId: string) => {
  return axiosInstance
    .get(`/patients/patients/${patientId}/tasks`)
    .then(r => r.data.tasks);
};

export const getPatientFiles = async (patientId: string) => {
  return axiosInstance
    .get<{ patientFiles: CarePlanFile[] }>(
      `/patients/patients/${patientId}/patient_files`,
    )
    .then(r => r.data.patientFiles);
};
